import React from 'react';
import './membershipItemSummary.module.scss';
import { StrikeThrough } from '../format/StrikeThrough';
import { CampaignSummary } from '../../molecules/applications/base';
import type { MembershipItemIndexView } from '../../../types/membershipPlans';

export const MembershipItemSummary = ({ item }: { item: MembershipItemIndexView }) => {
  return (
    <div styleName="summary-wrapper">
      <div styleName="summary">
        <div styleName="name">{item.name}</div>
        <div styleName="price-wrapper">
          {item.base_price !== item.price && (
            <div styleName="original-price">
              <StrikeThrough styleName="price-without-tax" lineColor="gray">
                {item.price.toLocaleString()}円
              </StrikeThrough>
              <StrikeThrough styleName="price-with-tax" lineColor="gray">
                （税込 {item.price_with_tax.toLocaleString()}円）
              </StrikeThrough>
            </div>
          )}
          <div styleName="price">
            <div styleName="price-without-tax">
              <span styleName="price-number">{item.base_price.toLocaleString()}</span>円
            </div>
            <div styleName="price-with-tax">（税込 {item.total_price.toLocaleString()}円）</div>
          </div>
        </div>
      </div>
      {item.discount_campaigns.map((d) => {
        return (
          d.discount > 0 && (
            <div styleName="item-footer">
              <CampaignSummary discount={d} unit={'円'} />
            </div>
          )
        );
      })}
    </div>
  );
};
